"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { ArrowUp, MessageCircle } from "lucide-react";

import { Button } from "@/components/ui/button";

type FloatingActionsProps = {
  whatsappLink: string;
};

export function FloatingActions({ whatsappLink }: FloatingActionsProps) {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setShowTop(window.scrollY > 300);
    };

    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="pointer-events-none fixed bottom-6 right-4 z-50 flex items-end gap-3 sm:right-8">
      <div
        className={`pointer-events-auto transition-all duration-300 ${
          showTop ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-2 opacity-0"
        }`}
      >
        <Button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          size="icon"
          className="h-12 w-12 rounded-full border border-[#35A29F]/40 bg-[#F2F7A1] text-[#071952] shadow-lg"
        >
          <ArrowUp className="h-5 w-5" />
          <span className="sr-only">Kembali ke atas</span>
        </Button>
      </div>

      <div className="pointer-events-auto transition duration-300">
        <Button
          asChild
          className="flex h-12 items-center gap-2 rounded-full bg-linear-to-r from-[#35A29F] to-[#088395] px-5 text-white shadow-[0_20px_45px_-20px_rgba(8,131,149,1)] hover:brightness-110"
        >
          <Link href={whatsappLink} prefetch={false}>
            <MessageCircle className="h-5 w-5" />
            WhatsApp
          </Link>
        </Button>
      </div>
    </div>
  );
}
